<app-common-header></app-common-header>
<div class="col-12 text-center webview">
  <!-- <img src="assets/images/eva-icons.svg" class="signimg signimgg" width="100" /> -->
</div>
<main role="main" class="maincnt outterbox quest">
  <div class="webview container pt-3">
    <div class="getbannersect sectppad pb-2 p-0">
      <div class="sectpad container">
        <!-- <div class="col-sm-12 p-0">

           <a href="javascript:void(0)" class="backbtn webview" (click)="back()"></a>
        </div> -->
      </div>
    </div>
    <!-- <h1 class="text-center fnt25 mt-4 semi-bold lnehgt40 userName">{{name}} your Honest Recommendation is ready!</h1> -->
    <h2 class="text-center recommendation mb-4">Honest Recommendation</h2>
    <!-- <div *ngIf="recommendationObj && recommendationObj.service_type == 'Switching Providers'" class="text-center discountsize">Your new price after a <font class="pdfclr">{{ recommendationObj.res_products_recommendations[0].new_tier.discount_percent }}% </font>discount
      off your recent bill!
   </div> -->
    <div class="brderbotm col-lg-7 col-sm-7 m-auto webview"></div>

    <div class="container">
      <div
        class="
          col-lg-8
          m-auto
          col-md-8 col-sm-9
          honest-box
          text-center
          initialimg
        "
        id="newsrve"
      >
        <div class="text-center col-lg-12 col-md-12 col-sm-12 m-auto pt-4 pb-4">
          <h1 class="font36 lnehgt35 font-weight-bold-calibre">
            Your household, lifestyle and usage profile suggests the following
            recommended plan:
          </h1>
          <!-- <h1 class="font36 lnehgt35 font-weight-bold-calibre">Your new price after a <font class="pdfclr"> {{discount}}% </font>
                discount off your recent bill!</h1> -->
        </div>
        <div class="row">
          <div class="col-4 pt-4">
            <div class="square d-inline-block">
              <a class="font14 avgfntwgt lnehgt18 font-weight-normal-calibre"
                >Avg. Price</a
              >
              <br />
              <a class="text-center cent font-weight-bold-calibre avgrecentbill"
                >{{ averagePrice }}<span>&#162;</span>
              </a>
              <br />
              <a class="font-weight-normal-calibre lnehgt18 font14">per kWh*</a>
            </div>
          </div>
          <div class="col-4 pt-4">
            <div class="square d-inline-block">
              <a class="font14 avgfntwgt lnehgt18 font-weight-normal-calibre"
                >Avg. Bill Estimate</a
              >
              <br />
              <!-- <a class="clr text-center font-weight-bold-calibre" id="avgbill"><span>&#36;</span>{{recommendProduct ?
               recommendProduct.new_tier.ave_monthly_bill.toFixed(1) : '-'}}</a> -->
              <a class="clr text-center font-weight-bold-calibre avgrecentbill"
                ><span>&#36;</span>{{ recommendProduct ? avgbill : '-' }}</a
              >
              <br />
              <a class="font-weight-normal-calibre lnehgt18 font14"
                >per month*</a
              >
            </div>
          </div>
          <div class="col-4 pt-4">
            <div class="square d-inline-block">
              <a class="font14 avgfntwgt lnehgt18 font-weight-normal-calibre"
                >Avg. Monthly Usage</a
              >
              <br />
              <a
                class="clr text-center font-weight-bold-calibre avgrecentbill"
                >{{ avgMthlyUsage }}</a
              >
              <br />
              <a class="font-weight-normal-calibre lnehgt18 font14">kWh*</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mobileview">
    <div class="initialimg">
      <div class="getbannersect sectppad pb-2 p-0">
        <div class="sectpad container-fluid"></div>
      </div>
      <!-- <h1 class="text-center mt-3 mbname userName">{{name}} your Honest Recommendation is ready!</h1> -->
      <h2 class="text-center recommendation mb-4 mbhonest">
        Honest Recommendation
      </h2>
      <!-- <div *ngIf="recommendationObj && recommendationObj.service_type == 'Switching Providers'" class="text-center discountsize">Your new price after a <font class="pdfclr">{{ recommendationObj.res_products_recommendations[0].new_tier.discount_percent }}% </font>discount
      off your recent bill!
   </div> -->
      <div
        *ngIf="
          recommendationObj &&
          recommendationObj.service_type == 'Switching Providers'
        "
        class="text-center"
      >
        <h1 class="mbbill">
          Your household, lifestyle and usage profile suggests:
        </h1>
        <!-- <h1 class="mbbill">Your new price after a <font class="pdfclr"> {{discount}}% </font><br>
          discount off your recent bill!</h1> -->
      </div>

      <div
        class="row col-lg-6 m-auto col-md-8 col-sm-9 honest-box text-center"
        id="newsrve"
      >
        <div class="col-4 pt-4">
          <div class="square d-inline-block">
            <a class="font12 font-weight-normal-calibre lnehgt13 lnehgt36"
              >Avg Price per kWh*
            </a>
            <br />
            <a class="text-center cent font-weight-bold-calibre avgrecentbill"
              >{{ averagePrice }}<span>&#162;</span>
            </a>
            <br />
            <a class="font-weight-normal-calibre font12 lnehgt13">per kWh</a>
          </div>
        </div>
        <div class="col-4 pt-4">
          <div class="square d-inline-block">
            <p class="font12 lineh-1">Avg.Monthly Bill <br />Estimate</p>
            <div class="clear"></div>
            <!-- <a class="clr text-center font-weight-bold-calibre avgvalue"><span>&#36;</span>{{recommendProduct ?
             recommendProduct.new_tier.ave_monthly_bill.toFixed(1) : '-'}}</a> -->
            <a class="clr text-center font-weight-bold-calibre avgrecentbill"
              ><span>&#36;</span>{{ recommendProduct ? avgbill : '-' }}</a
            >
            <br />
            <a class="font-weight-normal-calibre font12 lnehgt13">per month</a>
          </div>
        </div>
        <div class="col-4 pt-4">
          <div class="square d-inline-block">
            <a class="font12 font-weight-normal-calibre lnehgt13 lnehgt36"
              >Avg Monthly Usage</a
            >
            <br />
            <a class="clr text-center font-weight-bold-calibre avgrecentbill">{{
              avgMthlyUsage
            }}</a>
            <br />
            <a class="font-weight-normal-calibre font12 lnehgt13">kWh</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="text-center prod numtop">
     1095 other customers chose this product too!
   </div> -->
  <div class="text-center mt-3" id="accordion">
    <a
      class="
        btn
        signup
        font18
        font-weight-bold-calibre
        sectbtnhvr
        mt-0
        mbsign
        fontWeightBlack
      "
      (click)="signmeup()"
      >SIGN ME UP</a
    ><br />
    <!-- <a class="pdfclr semi-bold font13 lnehgt15 mdsee" > SEE PRODUCT DETAILS </a> -->
    <!-- <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne"></a> -->
    <!-- <i class="fa fa-angle-right pdfclr" data-toggle="collapse" data-parent=".d-accordion"  aria-hidden="true" (click)="showDetail()"></i> -->

    <div class="continer">
      <div class="single-pdct">
        <div class="panel-groupp" id="accordion">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a
                  class="
                    pdfclr
                    semi-bold
                    font13
                    lnehgt15
                    mdsee
                    collapsed
                    letterSpacee
                  "
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#"
                  aria-hidden="true"
                  (click)="see()"
                  id="ordernowarrow"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  SEE PRODUCT DETAILS
                </a>
              </h4>
            </div>
            <div
              id="collapseOne"
              class="
                panel-collapse
                collapse
                col-lg-8 col-sm-7
                m-auto
                pt-3
                pb-3
                hgtauto
              "
              [collapse]="showDetal"
            >
              <div class="panel-bodyy">
                <div
                  class="col-sm-10 m-auto pt-3 pb-3"
                  id="collapseOne"
                  class="panel-collapse"
                >
                  <div class="plansummary col-sm-9 m-auto px-0 othershadw">
                    <div class="d-flex bdrbot pr-0">
                      <div
                        class="
                          col-4 col-sm-3 col-md-2 col-lg-3
                          py-2
                          mob-pt-5
                          planrate
                          text-center
                        "
                      >
                        <div class="minhgt50p rateamt brdbottom">
                          <div class="w-100">
                            <h1
                              class="clrpink fwgtsix pikclr avgvalue"
                              style="padding-top: 30px"
                            >
                              {{ averagePrice }}¢
                            </h1>
                            <p style="line-height: 13px">Avg. Price per kWh*</p>
                          </div>
                        </div>
                        <div class="minhgt50p rateamt">
                          <div class="w-100">
                            <h1
                              class="fwgtsix rate mt-0 mob-pt-5 avgvalue"
                              style="padding-top: 30px"
                            >
                              ${{ recommendProduct ? avgbill : '-' }}
                            </h1>
                            <p style="line-height: 13px">
                              Avg. Monthly Bill Estimate
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 col-md-10 col-lg-9 p-0">
                        <table class="plansection">
                          <colgroup>
                            <col width="40%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td class="bdrbotgry bdrrgtgry position-relative">
                                <div class="w-50 float-left pr-2 mblogo">
                                  <img
                                    src="{{
                                      recommendProduct.energy_provider_image
                                    }}"
                                  />
                                  <!-- <div id="imgclass">
                                  <img src="assets/images/oncorenergy.png" width="100%">
                                </div> -->
                                  <p
                                    class="
                                      m-1
                                      font15
                                      font-weight-normal-calibre
                                    "
                                    id="puctid"
                                  >
                                    PUCT #{{ recommendProduct.puct }}
                                  </p>
                                </div>
                                <!-- <div class="mob-pl-0 w-50 float-left pl-2">
                                <p class="fwgtsix text-left">Energy Provider</p>
                                <p class="font-weight-normal-calibre wrdbrk text-left">{{recommendProduct.energy_provider}}</p>
                              </div> -->
                              </td>
                              <td class="bdrbotgry pl-2 bdrrgtgry">
                                <p class="fwgtsix text-left">Plan Name</p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                >
                                  {{ recommendProduct.product_key }}
                                </p>
                              </td>
                              <td class="bdrbotgry-1 bdrrgtgry wd50 pl-2">
                                <p class="fwgtsix text-left">Term</p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                >
                                  {{ recommendProduct.terms }} Months
                                  {{ recommendProduct.categoryName }}
                                </p>
                                <!-- <p class="font-weight-normal-calibre wrdbrk text-left">{{recommendProduct.categoryName}}</p> -->
                                <br />
                              </td>
                              <td class="bdrbotgry-1 wd50 wrdbrk pl-2">
                                <p class="fwgtsix text-left">
                                  Early Cancellation
                                </p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                  *ngIf="
                                    recommendProduct.ETF &&
                                    recommendProduct.ETFTypeId != 2
                                  "
                                >
                                  ${{ recommendProduct.ETF }}
                                </p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                  *ngIf="
                                    recommendProduct.ETF &&
                                    recommendProduct.ETFTypeId === 2
                                  "
                                >
                                  ${{ recommendProduct.ETF }} per month
                                  remaining
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="plan webview">
                          <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                            <p class="fwgtsix text-left">Description</p>
                            <p class="font-weight-normal-calibre text-left">
                              {{ recommendProduct.description }}
                            </p>
                          </div>
                          <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                            <p class="fwgtsix text-left font15">
                              Pricing Details
                            </p>
                            <table class="plantbl text-center">
                              <thead>
                                <th class="fwgtthree" width="28%">
                                  Monthly Usage
                                </th>
                                <th
                                  *ngFor="let usageObj of recommendProduct.tier"
                                  class="
                                    tabpad
                                    brdrgtblk
                                    font-weight-normal-calibre
                                    fwgtthree
                                  "
                                >
                                  {{ usageObj.usage }} kWh
                                </th>
                                <th
                                  class="
                                    radius2
                                    last-th
                                    font-weight-bold-calibre
                                  "
                                >
                                  <span class=""></span>{{ avgMthlyUsage }} kWh
                                </th>
                              </thead>
                              <tbody>
                                <td class="tabpadd radius4 brdrgtblk semi-bold">
                                  Average Price per kWh
                                </td>
                                <td
                                  *ngFor="let usageObj of recommendProduct.tier"
                                  class="tabpadd brdrgtblk semi-bold"
                                >
                                  {{ (usageObj.avg_charge * 100).toFixed(1)
                                  }}<span>&#162;</span>
                                </td>
                                <td
                                  class="
                                    tabpadd
                                    radius3
                                    last-th
                                    pdfclr
                                    semi-bold
                                  "
                                >
                                  {{
                                    (
                                      recommendProduct.new_tier
                                        .ave_price_per_KWH * 100
                                    ).toFixed(1)
                                  }}¢<font class="fwgtthree"
                                    >Your Avg&#42;</font
                                  >
                                </td>
                              </tbody>
                            </table>
                            <p
                              class="
                                text-left
                                font15
                                font-weight-normal-calibre
                                hand-symbol
                              "
                              *ngIf="partialText"
                              (click)="showText()"
                            >
                              *The estimates have been calculated to include all
                              recurring charges you will see on your bill,
                              excluding government fees and taxes. All
                              numbers...
                            </p>
                            <p
                              class="
                                text-left
                                font15
                                font-weight-normal-calibre
                                content-scroll
                                hand-symbol
                              "
                              *ngIf="fullText"
                            >
                              *The estimates have been calculated to include all
                              recurring charges you will see on your bill,
                              excluding government fees and taxes. All numbers
                              are estimates based on information provided by you
                              and each energy company. These estimates should be
                              confirmed using the information found in the
                              Electricity Facts Label and Terms of Service.
                              Please note, your Average Price per kWh and
                              Average Monthly Bill Estimate will vary each month
                              according to your actual usage.
                            </p>
                          </div>
                        </div>
                        <div class="webview">
                          <div class="d-flex p-2 text-left">
                            <!-- <div
                              class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2 pl-0"
                              *ngIf="!recommendProduct.Renewable"
                            >
                              <img src="" width="18" />&nbsp;<a
                                class="pikclr pl-1"
                                target="_blank"
                                >4% Renewable Energy
                              </a>
                            </div> -->

                            <div
                              class="
                                col-sm-4 col-md-4 col-lg-4
                                plandesc
                                pt-2
                                pl-0
                              "
                              *ngIf="recommendProduct.Renewable"
                            >
                              <img
                                src="assets/images/leaf.png"
                                width="18"
                              />&nbsp;<a class="pikclr pl-1" target="_blank"
                                >{{ recommendProduct.Renewable }}% Renewable
                                Energy
                              </a>
                            </div>

                            <div class="d-flex flex-row pt-2 pl-2">
                              <div
                                class="col-4 flexauto forallmore pl-1 text-left"
                              >
                                <img
                                  src="assets/images/pdf.svg"
                                  width="18"
                                />&nbsp;<a
                                  class="pikclr pl-1"
                                  href="{{ recommendProduct.productEFL }}"
                                  target="_blank"
                                  >Electricity Facts Label</a
                                >
                              </div>
                              <div class="col-3 flexauto forallmore text-left">
                                <img
                                  src="assets/images/pdf.svg"
                                  width="18"
                                />&nbsp;<a
                                  class="pikclr pl-1"
                                  href="{{ recommendProduct.productTOS }}"
                                  target="_blank"
                                  >TOS
                                </a>
                              </div>
                              <div class="col-5 flexauto forallmore text-left">
                                <img
                                  src="assets/images/pdf.svg"
                                  width="18"
                                />&nbsp;<a
                                  class="pikclr pl-1"
                                  href="{{ recommendProduct.productYRAC }}"
                                  target="_blank"
                                  >YRAC</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="plan mobileview">
                      <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                        <p class="fwgtsix">Description</p>
                        <p class="font-weight-normal-calibre">
                          {{ recommendProduct.description }}
                        </p>
                      </div>
                      <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                        <p class="fwgtsix text-left font15">Pricing Details</p>
                        <table class="plantbl text-center">
                          <thead>
                            <!-- <th class="fwgtthree" width="28%">Monthly Usage</th>
                     <th class="fwgtthree">500 kWh</th>
                     <th class="fwgtthree">1000 kWh</th>
                     <th class="fwgtthree">2000 kWh</th>
                     <th class="fwgtthree bold">{{avgMthlyUsage}} kWh</th> -->
                            <th class="fwgtthree" width="28%">Monthly Usage</th>
                            <th
                              *ngFor="let usageObj of recommendProduct.tier"
                              class="
                                tabpad
                                brdrgtblk
                                font-weight-normal-calibre
                                fwgtthree
                              "
                            >
                              {{ usageObj.usage }} kWh
                            </th>
                            <th
                              class="radius2 last-th font-weight-bold-calibre"
                            >
                              <span class=""></span>{{ avgMthlyUsage }} kWh
                            </th>
                          </thead>
                          <tbody>
                            <!-- <td class="text-center" width="28%">Average</td>
                     <td>{{t1_avg_charge}}¢</td>
                     <td>{{t2_avg_charge}}¢</td>
                     <td>{{t3_avg_charge}}¢</td>
                     <td>{{averagePrice}}¢<font>Your Avg&#42;</font>
                     </td> -->
                            <td class="tabpadd radius4 brdrgtblk semi-bold">
                              Average Price per kWh
                            </td>
                            <td
                              *ngFor="let usageObj of recommendProduct.tier"
                              class="tabpadd brdrgtblk semi-bold"
                            >
                              {{ (usageObj.avg_charge * 100).toFixed(1)
                              }}<span>&#162;</span>
                            </td>
                            <td
                              class="tabpadd radius3 last-th pdfclr semi-bold"
                            >
                              {{
                                (
                                  recommendProduct.new_tier.ave_price_per_KWH *
                                  100
                                ).toFixed(1)
                              }}¢<font
                                class="fwgtthree"
                                style="line-height: 12px"
                                >Your Avg&#42;</font
                              >
                            </td>
                          </tbody>
                        </table>
                        <p
                          class="text-left font15 font-weight-normal-calibre"
                          *ngIf="partialText"
                          (click)="showText()"
                        >
                          *The estimates have been calculated to include all
                          recurring charges you will see on your bill, excluding
                          government fees and taxes. All numbers...
                        </p>
                        <p
                          class="
                            text-left
                            font15
                            font-weight-normal-calibre
                            content-scroll
                          "
                          *ngIf="fullText"
                        >
                          *The estimates have been calculated to include all
                          recurring charges you will see on your bill, excluding
                          government fees and taxes. All numbers are estimates
                          based on information provided by you and each energy
                          company. These estimates should be confirmed using the
                          information found in the Electricity Facts Label and
                          Terms of Service. Please note, your Average Price per
                          kWh and Average Monthly Bill Estimate will vary each
                          month according to your actual usage.
                        </p>
                      </div>
                    </div>
                    <div class="mobileview">
                      <div class="d-flex mt-1 p-3 mb-2">
                        <div
                          class="
                            col-4
                            d-flex
                            flex-row
                            forallmore
                            pl-0
                            text-left
                          "
                          *ngIf="!recommendProduct.Renewable"
                        >
                          <div class="float-left mr-1"><img width="18" /></div>
                          <div>
                            <a class="float-left pikclr pt-1" target="_blank"
                              >4% Renewable Energy</a
                            >
                          </div>
                        </div>

                        <div
                          class="
                            col-4
                            d-flex
                            flex-row
                            forallmore
                            pl-0
                            text-left
                          "
                          *ngIf="recommendProduct.Renewable  && recommendProduct.energy_provider !== 'Texpo Energy'"
                        >
                          <div class="float-left mr-1">
                            <img src="assets/images/leaf.png" width="18" />
                          </div>
                          <div>
                            <a
                              class="float-left pikclr pt-1 pl-1"
                              target="_blank"
                              >{{ recommendProduct.Renewable }}% Renewable</a
                            >
                          </div>
                        </div>

                        <div
                          class="
                            col-2
                            d-flex
                            flex-row
                            forallmore
                            pl-0
                            text-left
                          "
                        >
                          <div class="float-left mr-1">
                            <img src="assets/images/pdf.svg" width="18" />
                          </div>
                          <div>
                            <a
                              class="float-left pikclr pt-1 pl-1"
                              href="{{ recommendProduct.productEFL }}"
                              target="_blank"
                              >EFL</a
                            >
                          </div>
                        </div>

                        <div
                          class="
                            col-2
                            d-flex
                            flex-row
                            flexauto
                            forallmore
                            text-left
                          "
                        >
                          <div class="float-left mr-1">
                            <img src="assets/images/pdf.svg" width="18" />
                          </div>
                          <div>
                            <a
                              class="float-left pikclr pt-1 pl-1"
                              href="{{ recommendProduct.productTOS }}"
                              target="_blank"
                              >TOS</a
                            >
                          </div>
                        </div>
                        <div
                          class="
                            col-4
                            d-flex
                            flex-row
                            flexauto
                            forallmore
                            pr-0
                            text-left
                          "
                        >
                          <div class="float-left mr-1">
                            <img src="assets/images/pdf.svg" width="18" />
                          </div>
                          <div>
                            <a
                              class="float-left pikclr pt-1 pl-1"
                              href="{{ recommendProduct.productYRAC }}"
                              target="_blank"
                              >YRAC</a
                            >
                          </div>
                        </div>
                      </div>
                      <div class="text-center m-auto pb-2">
                        <!-- <a class="btn signup font20 sectbtnhvr mt-0 mbsign fontWeightBlack">SIGN ME UP</a><br> -->
                        <i
                          class="fa fa-angle-up font33 pdfclr"
                          aria-hidden="true"
                          (click)="showDetail()"
                        ></i>
                        <!-- <a class="font33 pdfclr semi-bold font13 lnehgt15 mdsee" (click)="showDetail()"> </a> -->
                        <!-- <a class="font33" (click)="showDetail()"> ></a> -->
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        recommendationObj &&
        recommendationObj.service_type == 'Switching Providers'
      "
      class="text-center m-auto"
    >
      <p class="font16 semi-bold lineh-1 mbhow">
        This product may cost more or less than your current plan due to current
        market conditions.
      </p>
    </div>
    <div class="d-flex mt-2">
      <div class="col-sm-10 col-md-6 col-lg-5 text-center m-auto">
        <!-- <img src="assets/images/chart2.png"> -->
        <!-- <div [chart]="chart"></div> -->
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="highChartsOptions"
          [(update)]="updateValue"
          [runOutsideAngular]="true"
          style="width: 100%; height: 350px; display: block"
        ></highcharts-chart>
        <!-- <span class="font-weight-semibold-calibre" *ngIf="recommendationObj && recommendationObj.service_type == 'Switching Providers' && recommendProduct.new_tier.discount_percent > 0">Avg. Annual Savings: {{recommendProduct.new_tier.discount_percent }}%</span> &nbsp; -->
        <span class="font-weight-semibold-calibre"
          >Avg. Monthly Bill Estimate: ${{
            recommendProduct ? avgbill : '-'
          }}</span
        >
        &nbsp;
        <span class="font-weight-semibold-calibre avgalign"
          >Avg. Price per kWh:
          {{
            recommendProduct
              ? (recommendProduct.new_tier.ave_price_per_KWH * 100).toFixed(1) +
                '¢'
              : ''
          }}</span
        >
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-3 avgdetail">
      <a
        class="
          btnimpl
          navboxclr
          initial-btnn
          ml-0
          mr-3
          font15
          btnpad
          letterSpacee
        "
        routerLink="/recommendation/compare-product/{{ accountId }}"
        >COMPARE WITH OTHER PLANS</a
      >
    </div>
    <div
      class="
        col-sm-10 col-md-6 col-lg-5
        text-left
        m-auto
        pb-4
        font-weight-normal-calibre
        avgdetl
      "
    >
      <a
        >*The estimates provided here and throughout the website have been
        calculated to include all of the recurring charges that you will see on
        your bill, excluding government fees and taxes. All numbers presented
        are estimates based on information provided by you and each energy
        company. These estimates should be confirmed using the information found
        in the Electricity Facts Label and Terms of Service. Please note, your
        Average Price per kWh and Average Monthly Bill Estimate will vary each
        month according to your actual usage, as illustrated in the bar chart
        above.</a
      >
    </div>
  </div>
</main>
<!--Added by Vijay-->
<ng-template #newEnergyRates>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="modalRef.hide()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        THESE OFFERS HAVE EXPIRED
      </h4>
      <p class="utility-sub-title font20">
        PRICE FLASH! Due to market volatility, this price is no longer being
        offered by the energy provider you have selected. However, this update
        could possibly work in your favor!
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click the button below 👇 to see new rates.
      </p>
      <br />
      <p class="utility-sub-title font20">
        We appreciate your patience, and apologize In advance for any
        inconvenience, while we update our records. This may take a few seconds.
      </p>
      <div class="col-12 text-center">
        <button
          class="
            btn
            mr-2
            ml-2
            col-12
            font-weight-bold-calibre
            contbtn
            text-uppercase
            mb-3
          "
          (click)="newEnergyProviderRates()"
        >
          see new rates
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!--End-->
